import { memo } from 'react';
import { useReduxState } from 'hooks';
import { DropdownButton } from 'components/common/dropdown';
import { useEditorDispatch } from 'components/editor';

const EditorHeaderChapterVersionHistory = () => {
  const editorDispatch = useEditorDispatch();

  const { messages } = useReduxState();

  const handleChangeView = () =>
    editorDispatch({
      type: 'updateContext',
      update: { editorActiveView: 'chapter-version-history' }
    });

  return (
    <DropdownButton
      category="light"
      onClick={handleChangeView}
      icon="history"
      text={messages.coursesChapterVersionHistory}
    />
  );
};

export default memo(EditorHeaderChapterVersionHistory);
